const BackCircle = (props) => (
  <svg width='25.339' height='25.339' viewBox='0 0 25.339 25.339' {...props}>
    <path
      id='e977'
      d='M12.669,0a12.418,12.418,0,0,1,4.937.99,12.611,12.611,0,0,1,6.743,6.743,12.418,12.418,0,0,1,.99,4.937,12.418,12.418,0,0,1-.99,4.937,12.611,12.611,0,0,1-6.743,6.743,12.418,12.418,0,0,1-4.937.99,12.418,12.418,0,0,1-4.937-.99A12.611,12.611,0,0,1,.99,17.606,12.418,12.418,0,0,1,0,12.669,12.418,12.418,0,0,1,.99,7.733,12.611,12.611,0,0,1,7.733.99,12.418,12.418,0,0,1,12.669,0ZM7.5,13.362l4.479,4.479a.788.788,0,1,0,1.114-1.114L9.824,13.461h8.388a.792.792,0,0,0,0-1.584H9.824L13.09,8.611a.75.75,0,0,0,0-1.114.75.75,0,0,0-1.114,0L7.5,11.976a.737.737,0,0,0-.2.334.662.662,0,0,0,0,.359.662.662,0,0,0,0,.359A.737.737,0,0,0,7.5,13.362Z'
      fill='#0e77ef'
    />
  </svg>
)

export default BackCircle
